import {Injectable} from '@angular/core';

import {SodiumServiceBase} from "./sodium.service.base";

@Injectable({
  providedIn: 'root'
})
export class SodiumService extends SodiumServiceBase {
}
